<template>
  <div class="leaflets-container">
    <Breadcrumb :items="breadCrumbs" />
    <category-block
      :target="category"
      position="position1"
      class="category-block category-block-1"
    />
    <v-container>
      <CategoryTitle :category="category" />
      <div v-if="$vuetify.breakpoint.smAndDown">
        <v-row>
          <v-col
            v-for="leaflet in leaflets"
            :key="leaflet.leafletId"
            cols="12"
            class="px-7"
            ><div class="leaflet-descr py-4">
              <h3 class="mt-1 mt-sm-2 mt-md-0">{{ leaflet.title }}</h3>
            </div>
            <LeafletCard :leaflet="leaflet" />
          </v-col>
        </v-row>
      </div>
      <leaflets-slider v-else :leaflets="leaflets" :parentLeafletTypeId="1" />
    </v-container>
    <category-block
      :target="category"
      position="position2"
      class="category-block category-block-2"
    />
    <category-block
      :target="category"
      position="position3"
      class="category-block category-block-3"
    />

    <v-container>
      <ebsn-meta
        :target="category"
        path="category_info.FOOTER_DESCRIPTION"
        tag="div"
      />
    </v-container>
  </div>
</template>
<script>
import LeafletCard from "@/components/leaflet/LeafletCard.vue";
import get from "lodash/get";
import Breadcrumb from "@/components/navigation/Breadcrumb";
import categoryMixin from "~/mixins/category";
import CategoryTitle from "@/components/category/CategoryTitle.vue";
import LeafletsSlider from "@/components/leaflet/LeafletsSlider.vue";
import leafletService from "~/service/leafletService.js";
import { mapState, mapGetters } from "vuex";

export default {
  name: "Leaflets",
  components: {
    Breadcrumb,
    CategoryTitle,
    LeafletsSlider,
    LeafletCard
  },
  mixins: [categoryMixin],
  data() {
    return {
      leaflets: [],
      breadCrumbs: [
        { to: { name: "Home" }, text: "Homepage", exact: true },
        { text: "Volantini" }
      ],
      filteredLeaflets: []
    };
  },
  computed: {
    ...mapState({
      cart: ({ cart }) => cart.cart
    }),
    ...mapGetters({
      isAuthenticated: "cart/isAuthenticated"
    })
  },
  async mounted() {
    const warehouseId = get(this.cart, "warehouse.warehouseId", null);
    const deliveryServiceId = get(
      this.cart,
      "shippingAddress.deliveryServiceId",
      null
    );
    this.leaflets = await leafletService.search({
      parent_warehouse_id: warehouseId,
      parent_leaflet_type_id: this.parentLeafletTypeId,
      parent_delivery_service_id: deliveryServiceId
    });

    // let _this = this;

    // if (_this.isAuthenticated) {
    //   let timeslotDate = _this
    //     .$dayjs(_this.cart.timeslot.date)
    //     .format("YYYY-MM-DD");

    //   this.filteredLeaflets = _this.leaflets.filter(leaflet => {
    //     let fromDate = _this.$dayjs(leaflet.fromDate).format("YYYY-MM-DD");
    //     let toDate = _this.$dayjs(leaflet.toDate).format("YYYY-MM-DD");

    //     return fromDate <= timeslotDate && timeslotDate <= toDate;
    //   });
    // } else {
    //   this.filteredLeaflets = this.leaflets;
    // }
  }
  // watch: {
  //   "cart.timeslot.date"(newvalue, oldvalue) {
  //     if (newvalue != oldvalue) {
  //       let _this = this;
  //       let timeslotDate = _this.$dayjs(newvalue).format("YYYY-MM-DD");

  //       this.filteredLeaflets = this.leaflets.filter(leaflet => {
  //         let fromDate = _this.$dayjs(leaflet.fromDate).format("YYYY-MM-DD");
  //         let toDate = _this.$dayjs(leaflet.toDate).format("YYYY-MM-DD");

  //         return fromDate <= timeslotDate && timeslotDate <= toDate;
  //       });
  //     }
  //   }
  // }
};
</script>
